import { DashboardCard } from "@dashboard/components/Card";
import { StaffErrorFragment } from "@dashboard/graphql";
import { getFormErrors } from "@dashboard/utils/errors";
import { TextField } from "@material-ui/core";
import { Box, Text } from "@saleor/macaw-ui-next";
import { ChangeEvent } from "react";
import { useIntl } from "react-intl";

import { staffSignInMessages as messages } from "../../messages";

interface StaffSignInProps {
  data: { username: string; password: string };
  disabled: boolean;
  errors: StaffErrorFragment[];
  onChange: (event: ChangeEvent<any>) => void;
}

// Username and admin-set password for the ops sign-in (staff without a mailbox).
export const StaffSignIn = ({ data, disabled, errors, onChange }: StaffSignInProps) => {
  const intl = useIntl();
  const formErrors = getFormErrors(["username", "password"], errors || []);

  return (
    <DashboardCard data-test-id="staff-sign-in">
      <DashboardCard.Header>
        <DashboardCard.Title>{intl.formatMessage(messages.opsSignIn)}</DashboardCard.Title>
      </DashboardCard.Header>
      <DashboardCard.Content>
        <Text size={2} color="default2" display="block" marginBottom={4}>
          {intl.formatMessage(messages.detailsHint)}
        </Text>
        <Box
          display="grid"
          gap={4}
          gridTemplateColumns={{
            mobile: 1,
            tablet: 2,
          }}
        >
          <TextField
            name="username"
            label={intl.formatMessage(messages.username)}
            value={data.username}
            onChange={onChange}
            disabled={disabled}
            error={!!formErrors.username}
            helperText={formErrors.username?.message}
            autoComplete="off"
            fullWidth
            inputProps={{ spellCheck: false, "data-test-id": "staffUsername" }}
          />
          <TextField
            name="password"
            type="password"
            label={intl.formatMessage(messages.newPassword)}
            value={data.password}
            onChange={onChange}
            disabled={disabled}
            error={!!formErrors.password}
            helperText={formErrors.password?.message}
            autoComplete="new-password"
            fullWidth
            inputProps={{ "data-test-id": "staffNewPassword" }}
          />
        </Box>
      </DashboardCard.Content>
    </DashboardCard>
  );
};
